<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="rect">
      <van-row>
        <van-col span="4"><img class="icon" :src="shopData.shop.icon"></van-col>
        <van-col span="1" />
        <van-col span="17">
          <div class="title pageTitle1">{{ shopData.shop.title }}</div>
          <van-rate
            v-model="shopData.score"
            size="1em"
            color="#E32119"
            void-icon="star"
            void-color="#eee"
            allow-half
            readonly
          />
          <div class="pagebody1 aboutStr">
            <span v-for="oneSport in shopData.divecenter.sport.split(',')" :key="oneSport">
              {{ $t('diveCenter.sport.'+oneSport) }}
            </span>
          </div>
        </van-col>
      </van-row>
      <van-swipe ref="TopSwipe" class="topad" :autoplay="6000" @change="onTopSwipe">
        <van-swipe-item v-for="(image, index) in images" :key="index">
          <img :src="image.img" style="width:100%" @click="topAdClick(image.url)">
        </van-swipe-item>
        <div v-if="images.length>0" slot="indicator" class="custom-indicator swipeTop">
          <span v-for="(image, index) in images" :key="index" @click="gotoTopSwipe(index)">
            <a v-if="NowTopSwipe == index" class="mainColor"><i class="iconfont iconline" /></a>
            <a v-if="NowTopSwipe != index"><i class="iconfont iconline" /></a>
          </span>
        </div>
      </van-swipe>
      <van-row>
        <van-col span="2"><i class="iconfont iconTel" /></van-col>
        <van-col span="22">{{ shopData.shop.telphone }}</van-col>
      </van-row>
      <van-row>
        <van-col span="2"><i class="iconfont iconaddress" /></van-col>
        <van-col span="22">{{ shopData.shop.address }}</van-col>
      </van-row>
    </div>
    <van-tabs class="rectTable" title-active-color="#E32119" animated>
      <van-tab class="tab" title="店铺详情" v-html="shopData.shop.about" />
      <van-tab class="tab" title="产品">
        <van-list
          v-model="loadingCommodity"
          :finished="finishedCommodity"
          @load="onLoadCommodity"
        >
          <div v-for="item in listCommodity" :key="item.id" class="commodity" @click="inCommodity(item.id)">
            <van-row>
              <van-col span="7"><img class="icon" :src="item.icon"></van-col>
              <van-col span="1" />
              <van-col span="16">
                <span class="pageTitle1 title">{{ item.title }}</span><br>
                <div class="downRect"><span class="price">￥{{ item.lowPrice }}</span><span class="pagebody2 aboutStr">月售{{ item.sellNum }} | 评价{{ item.commentNum }}</span></div>
              </van-col>
            </van-row>
          </div>
          <div v-if="listCommodity.length>0" class="CommodityMore"><van-button type="info" @click="onMoreCommodity">查看更多产品</van-button></div>
          <div v-if="listCommodity.length<=0" class="CommodityMore">暂无可售产品</div>
        </van-list>
      </van-tab>
      <van-tab class="tab" title="评价">
        <van-list
          v-model="loadingComment"
          :finished="finishedComment"
          finished-text="没有更多了"
          @load="onLoadComment"
        >
          <div v-for="item in listComment" :key="item.commentId" class="comment">
            <van-row>
              <van-col span="3">
                <van-image
                  width="3em"
                  height="3em"
                  fit="cover"
                  :src="item.userIcon"
                />
              </van-col>
              <van-col span="1" />
              <van-col span="18">
                <span class="pageTitle1">{{ item.userName }}</span><br>
                <span class="pagebody3 aboutStr">{{ formatDate(item.createTime,"yyyy-MM-dd") }} {{ item.specificaionName }}</span>
                <div class="body pagebody1">{{ item.body }}</div>
                <van-image
                  v-for="(img, index) in item.res"
                  :key="img"
                  class="photo"
                  :src="img"
                  fit="cover"
                  @click="PreviewUserImage(item.res,index)"
                />
              </van-col>
            </van-row>
          </div>
        </van-list>

      </van-tab>
    </van-tabs>

  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { initPage, getUrlKey, formatDate } from '@/utils/base'
import { Rate, Swipe, SwipeItem, Tab, Tabs, Image, ImagePreview, List, Button } from 'vant'
export default {
  name: 'Diveshop',
  components: {
    [Rate.name]: Rate,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Image.name]: Image,
    [ImagePreview.name]: ImagePreview,
    [List.name]: List,
    [Button.name]: Button,
    TopBar
  },
  data() {
    return {
      title: '演示页面',
      backurl: '/store/diveshopList',
      shopStar: 4.5,
      NowTopSwipe: 0,
      shopData: {
        shop: {
          icon: undefined
        }
      },
      listComment: [],
      loadingComment: false,
      finishedComment: false,
      searchComment: {
        shopCommodityId: undefined,
        limit: 30,
        page: 1
      },
      listCommodity: [],
      loadingCommodity: false,
      finishedCommodity: false,
      searchCommodity: {
        divecenter: 'MYDC',
        shopId: undefined,
        sort: 'BASE',
        course: '',
        limit: 30,
        page: 1
      },

      images: []
    }
  },
  created() {
    initPage()
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
    this.id = this.$route.params.id
    this.title = this.id
    this.searchComment.shopCommodityId = this.id
    this.searchCommodity.shopId = parseInt(this.id)
    request({
      url: '/Store/getShopInfo',
      method: 'get',
      params: { id: this.id }
    }).then(response => {
      if (!response.success) {
        this.error = true
        return
      }
      this.shopData = response.data
      this.title = this.shopData.shop.title
      this.images = []
      if (this.shopData.divecenter.image1 !== '') {
        this.images.push({
          img: this.shopData.divecenter.image1,
          url: undefined
        })
      }
      if (this.shopData.divecenter.image2 !== '') {
        this.images.push({
          img: this.shopData.divecenter.image2,
          url: undefined
        })
      }
      if (this.shopData.divecenter.image3 !== '') {
        this.images.push({
          img: this.shopData.divecenter.image3,
          url: undefined
        })
      }
      console.log('shopData', this.shopData)
    })
  },
  methods: {
    formatDate,
    PreviewUserImage(list, index) {
      ImagePreview({
        images: list,
        startPosition: index,
        minZoom: 1
      })
    },
    onTopSwipe(index) {
      this.NowTopSwipe = index
    },
    gotoTopSwipe(index) {
      this.NowTopSwipe = index
      this.$refs.TopSwipe.swipeTo(index)
    },

    onLoadComment() {
      this.loadingComment = true
      request({
        url: '/Store/getCommentList',
        method: 'post',
        data: this.searchComment
      }).then(response => {
        if (!response.success) {
          return
        }
        this.loadingComment = false
        this.searchComment.limit = response.data.limit
        this.searchComment.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.listComment.push(item)
        })
        if (response.data.rows.length < this.searchComment.limit) {
          this.finishedComment = true
        }
      })
    },
    onLoadCommodity() {
      this.loadingCommodity = true
      request({
        url: '/Store/getOneShopCommodityList',
        method: 'post',
        data: this.searchCommodity
      }).then(response => {
        if (!response.success) {
          return
        }
        this.loadingCommodity = false
        response.data.rows.forEach(item => {
          this.listCommodity.push(item)
        })
        this.finishedCommodity = true
      })
    },
    inCommodity(id) {
      this.$router.replace('/store/commodity/' + id + '?backurl=/store/diveshop/' + this.id)
    },
    onMoreCommodity() {
      this.$router.replace('/store/commodityList/' + this.id + '?backurl=/store/diveshop/' + this.id)
    }
  }
}
</script>
<style scoped>
.topad{
    margin: 0.8em 0;
}

.rect{
    padding: 1em;
    background-color: #fff;
}
.rectTable{
    margin-top: 1em;

}

.rectTable .tab{
    padding: 1em;
}
.rect .icon{
    width: 100%;
}
.title{
    margin-bottom: 0.4em;
}

.comment{
    border-bottom: 1px solid #dadada;
    margin: 1em 0;
    padding-bottom: 1em;

}
.comment .head{
    width: 100%;
}
.comment .body{
    margin-top: 0.8em;
}
.comment .photo{
    width: 3em;
    height: 3em;
    margin: 0.25em 0.25em 0 0;
}

.commodity{
     border-bottom: 1px solid #dadada;
    margin: 1em 0;
    padding-bottom: 1em;
    position: relative;
}
.commodity .icon{
    width: 100%;
}
.commodity .downRect{
    position: absolute;
    bottom: 1.2em;
    left: 33%;
    right: 0;
}
.commodity .downRect .price{
    color:#E32119;
    font-weight: 700;
    margin-right: 1.5em;
}
.commodity .title{
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
}
.CommodityMore{
  text-align: center;
}
.CommodityMore button{
  width: 100%;
}
</style>
